import React from 'react'

export default function Footer() {
    return (
        <div>
            <div className="footer1">
                    <p style={{marginBottom:'0px', fontSize:'20px'}}>Copyright © 2024 SEATECH</p>
            </div>
        </div>
    )
}